import "./MapRendererBMap.css"

import React, { useState } from 'react';
// import { blue } from '@ant-design/colors';
import { Card, Modal, Table } from 'antd';

import {
    Map,
    ZoomControl,
    MapvglLayer,
    MapvglView,
} from 'react-bmapgl';

import ProfileCard from './ProfileCard';

import darkstyle from '../../static/dark_map_config.json'
import lightstyle from '../../static/light_map_config.json'

const colorSingleton = 'rgba(64, 102, 255, 0.8)';
const colorCluster = 'rgba(0, 62, 179, 0.8)'

const popupTableColumn = [
    {
        title: '姓名',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '入学年份',
        dataIndex: 'year',
        key: 'year',
        sorter: (a, b) => a.year - b.year,
    },
    {
        title: '地址',
        dataIndex: 'loc',
        key: 'loc',
    },
]

function roundedRect(ctx, x, y, width, height, radius, color) {
    ctx.globalAlpha = 0.95;
    ctx.translate(0.5, 0.5);
    ctx.beginPath();
    ctx.moveTo(x, y + radius);
    ctx.arcTo(x, y + height, x + radius, y + height, radius);
    ctx.arcTo(x + width, y + height, x + width, y + height - radius, radius);
    ctx.arcTo(x + width, y, x + width - radius, y, radius);
    ctx.arcTo(x, y, x, y + radius, radius);
    ctx.fillStyle = color;
    ctx.strokeStyle = color;
    ctx.fill();
    ctx.stroke();
}

const singletonIcon = (props) => {
    var canvas = document.createElement('canvas');
    canvas.height = 100;
    canvas.width = 240;

    var ctx = canvas.getContext('2d');
    roundedRect(ctx, 0, 0, 240, 100, 30, colorSingleton);
    ctx.fillStyle = '#ffffff'
    ctx.textBaseline = 'middle';
    ctx.textAlign = "center";
    ctx.font = "50px Arial";
    ctx.fillText(props.name_cn, 120, 50);

    return canvas.toDataURL();
    // return 'http://map.baidu.com/image/us_mk_icon.png'
}

const ClusterModals = (props) => {

    const clusterChildren = props.clusterChildren;
    const [expandedProfile, setExpandedProfile] = useState({});
    const [profileModalOpen, setProfileModalOpen] = useState(false);

    const popupTableContent = clusterChildren.map((i, j) => {
        return {
            name: <a onClick={() => { setProfileModalOpen(true); setExpandedProfile(i.i) }}> {i.i.name_cn} </a>,
            loc: i.i.loc_country + ' ' + i.i.loc_city,
            year: i.i.schoolm_start_time,
            key: j
        }
    })

    return (<>
        <Table
            columns={popupTableColumn}
            dataSource={popupTableContent}
            size='small'
            pagination={false}
        />
        <Modal
            open={profileModalOpen}
            className='detailed-profile-modal'
            width="70vw"
            footer={null}
            onCancel={() => {
                setExpandedProfile({});
                setProfileModalOpen(false);
            }}
        >
            <ProfileCard profile={expandedProfile} />
        </Modal>
    </>);
}


// class MapRendererBMap extends React.Component {
const MapRendererBMap = (props) => {

    const alumniMapList = props.alumniMapList;
    const userProfile = props.userProfile;
    const locData = {
        type: "FeatureCollection",
        features: alumniMapList.filter(i => 
            i.loc_coord != null && 
            i.loc_coord.lat != null && 
            i.loc_coord.lon != null
        )
        .map(i => { return { 
            type: "Feature",
            geometry: { coordinates: [i.loc_coord.lon, i.loc_coord.lat], type: "Point" },
            properties: {...i, icon: singletonIcon(i)} 
        } })
    };
    
    const [expandedCluster, setExpandedCluster] = useState({});
    const [clusterModalOpen, setClusterModalOpen] = useState(false);

    const [expandedSingleton, setExpandedSingleton] = useState({});
    const [singletonModalOpen, setSingletonModalOpen] = useState(false);

    const getClusterChildren = (e, alumniListLocal) => {
        const clusterLon = e.dataItem.geometry.coordinates[0];
        const clusterLat = e.dataItem.geometry.coordinates[1];
        
        // Filter out the current user and only include alumni with location coordinates
        let filteredAlumni = props.alumniMapList.filter(i => 
            i.loc_coord != null && 
            i.loc_coord.lat != null && 
            i.loc_coord.lon != null &&
            (!userProfile || i.id !== userProfile.id)
        );
        
        const clusterChildren = filteredAlumni.map(
            i => {
                return {
                    lon_offset: Math.min(Math.abs(i.loc_coord.lon - clusterLon), Math.abs(i.loc_coord.lon - clusterLon + 360), Math.abs(i.loc_coord.lon - clusterLon - 360)),
                    lat_offset: i.loc_coord.lat - clusterLat,
                    distance: Math.sqrt(Math.pow(Math.min(Math.abs(i.loc_coord.lon - clusterLon), Math.abs(i.loc_coord.lon - clusterLon + 360), Math.abs(i.loc_coord.lon - clusterLon - 360)), 2) + Math.pow(i.loc_coord.lat - clusterLat, 2)),
                    i
                }
            }
        ).sort(
            (a, b) => a.distance - b.distance  // Sort by distance ascending (closest first)
        ).slice(0, e.dataItem.properties.point_count);  // Take the first N closest items
        
        return clusterChildren;
    };

    return <>
        <Map
            center={{ lng: 116.312477, lat: 39.973592 }}
            zoom="4"
            enableScrollWheelZoom
            enableTilt={false}
            mapStyleV2={{ styleJson: lightstyle }}
            className='alumni-map'
            // height="1000px"
            style={{ height: "600px" }}
        >
            <ZoomControl />
            {/* <NavigationControl /> */}
            {/* <MapvglView effects={['bloom']}> */}
            <MapvglView effects={{}}>
                <MapvglLayer
                    type="ClusterLayer"
                    data={locData.features}
                    options={{
                        textOptions: {
                            fontSize: 20,
                            fontFamily: "Arial",
                            color: 'white',
                        },
                        showText: true,
                        enablePicked: true,
                        minSize: 30,
                        maxSize: 50,
                        shape: 'circle',
                        alpha: 0.9,
                        iconOptions: {
                            width: 72,
                            height: 30,
                            // icon: "temp.png" // Custom icons could be added here if needed
                        },
                        //
                        gradient: {
                            0.0: colorSingleton,
                            1.0: colorCluster,
                        },
                        // Pass in hooks
                        alumniMapList: alumniMapList,
                        setExpandedCluster: setExpandedCluster,
                        setClusterModalOpen: setClusterModalOpen,
                        setExpandedSingleton: setExpandedSingleton,
                        setSingletonModalOpen: setSingletonModalOpen,
                        // Callback
                        onClick: (e) => {
                            if (e.dataItem) {
                                if (e.dataItem.children) {
                                    // Trigger the cluster view table

                                    const clusterChildren = getClusterChildren(e, alumniMapList);
                                    setClusterModalOpen(true);
                                    setExpandedCluster(clusterChildren);
                                }
                                else {
                                    // Directly trigger the profile card

                                    setSingletonModalOpen(true);
                                    setExpandedSingleton(e.dataItem.properties);
                                }
                            }
                        }
                    }}
                />
            </MapvglView>
        </Map>
        {/* Cluster Table selection */}
        <Modal
            open={clusterModalOpen}
            className='detailed-profile-modal'
            width="50%"
            centered
            footer={null}
            onCancel={() => {
                setExpandedCluster({});
                setClusterModalOpen(false);
            }}
        >
            <ClusterModals clusterChildren={expandedCluster} />
        </Modal>
        <Modal
            // title={expandedProfile.name_cn}
            open={singletonModalOpen}
            className='detailed-profile-modal'
            width="70vw"
            footer={null}
            onCancel={() => {
                setExpandedSingleton({});
                setSingletonModalOpen(false);
            }}
        >
            <ProfileCard profile={expandedSingleton} />
        </Modal>
    </>
}

export default MapRendererBMap;